import React from 'react'
import './DiscountBall.css'

const DiscountBall = ({ label, type }) => (
  <div className={`discount-ball ${type} d-flex`}>
    <div className="m-auto">{label}</div>
  </div>
)

export default DiscountBall